import { IGif } from "@/common/services/types";
import { useCallback, useState } from "react";

export const useGalleryGif = (gif: IGif) => {
  const [currentGalleryGif, setCurrentGalleryGif] = useState<IGif | null>(gif.gallery ? gif : null);

  const onSetGalleryGif = useCallback((gif: IGif) => {
    setCurrentGalleryGif(gif);
  }, []);

  return {
    currentGalleryGif,
    onSetGalleryGif
  };
};
